import React, { useState } from "react";
import ReusableTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/Reusable.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import DetailsView from "../../../../../components/PagesComponents/Financial/CashOutFlow/Charity/DetailsView.component";

const Body = ({
  reliefAndWelfareColumn,
  reliefAndWelfareData,
  coordinators = [],
  verifiers = [],
}) => {
  const [model, openModel] = useState(false);
  const onClose = () => {
    openModel(false);
  };
  return (
    <div
      style={{ display: "flex", margin: "1rem", gap: "1rem" }}
      className="EducationalMaterialContainer"
    >
      <ScrollableModal isOpen={model} onClose={onClose}>
        <DetailsView
          onClose={onClose}
          highlightKey="donationId"
          data={{
            "Donation id": "2398476282",
            "Scheme name": "Siksha vikash",
            "Whom to support": "Blind People",
            "Relief": "Education for blind people",
            "Eqvt. amount (INR)": "₹ 23,45",
            Coordinator: "Rafik Haldar",
            "Verified by": "Javed Habib",
          }}
          description="Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard."
        />
      </ScrollableModal>
      <div
        style={{ background: "white", padding: "1rem", borderRadius: "10px" }}
        className="formContaienr"
      >
        <h2
          style={{
            color: "var(--grayColor)",
            fontWeight: "400",
            borderBottom: "1px solid var(--borderGray)",
            paddingBottom: "1rem",
          }}
          className="form-title"
        >
          Donate as relief & welfare fund
        </h2>
        <div>
          <Formik
            initialValues={{
              schemeName: "",
              description: "",
              whomToSupport: "",
              relief: "",
              equivalentCost: "",
              coordinator: "",
              verifier: "",
            }}
            onSubmit={(values) => {
              console.log("Submitted:", values);
              openModel(true);
            }}
          >
            {({
              values,
              setFieldValue,
              handleSubmit,
              touched,
              errors,
              setTouched,
            }) => {
              return (
                <form onSubmit={handleSubmit} className="p-1">
                  {/* First Row */}
                  <div className="grid grid-cols-2 gap-4 mb-5">
                    <FormInput
                      label="Scheme name"
                      type="text"
                      name="schemeName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter the scheme name"
                      setFieldValue={(e) =>
                        setFieldValue("schemeName", e.target.value)
                      }
                    />

                    <FormInput
                      label="Description"
                      type="text"
                      name="description"
                      touched={touched}
                      errors={errors}
                      placeholder="Type something here"
                      setFieldValue={(e) =>
                        setFieldValue("description", e.target.value)
                      }
                    />

                    <FormInput
                      label="Whom to support"
                      type="text"
                      name="whomToSupport"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter low grade community"
                      setFieldValue={(e) =>
                        setFieldValue("whomToSupport", e.target.value)
                      }
                    />

                    <FormInput
                      label="Relief"
                      type="text"
                      name="relief"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter supporting relief"
                      setFieldValue={(e) =>
                        setFieldValue("relief", e.target.value)
                      }
                    />

                    <FormInput
                      label="Equivalent cost (INR)"
                      type="number"
                      name="equivalentCost"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter total cost"
                      setFieldValue={(e) =>
                        setFieldValue("equivalentCost", e.target.value)
                      }
                    />

                    <DropDownInput
                      name="coordinator"
                      label="Coordinator"
                      value={values.coordinator}
                      placeholder="Choose a coordinator"
                      suggestionList={coordinators}
                      setFieldValue={(val) => setFieldValue("coordinator", val)}
                    />

                    <DropDownInput
                      name="verifier"
                      label="Verifier"
                      value={values.verifier}
                      placeholder="Choose payment verifier"
                      suggestionList={verifiers}
                      setFieldValue={(val) => setFieldValue("verifier", val)}
                    />
                  </div>

                  {/* Submit */}
                  <button type="submit" className="actionBtn w-full mt-1">
                    Confirm
                  </button>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
      <ReusableTable
        title="Relief & welfare donation list"
        countLabel={`${reliefAndWelfareData.length} times`}
        columns={reliefAndWelfareColumn}
        data={reliefAndWelfareData}
        renderedElement={
          <div
            style={{ marginLeft: "auto", marginTop: "1rem" }}
            className="lightBlueInfoBox"
          >
            <span className="info-title">
              Total Educational material donation amount:
            </span>{" "}
            ₹ 2,60,560
          </div>
        }
        gridColumnStyle="1fr 1fr 1fr"
      />
    </div>
  );
};

export default Body;
